"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBMIT_READ_STORAGE_KEY = exports.PAGE_SIZE = exports.SMART_METER_NON_COMMS_DAYS = void 0;
exports.SMART_METER_NON_COMMS_DAYS = 5;
exports.PAGE_SIZE = 12;
exports.SUBMIT_READ_STORAGE_KEY = 'meterReadSubmissionsLatest';
